import { LinearTransform } from '@st/geom'
import { BoxConstraints, DrawOp, RenderBox, useRenderBox } from '../rendering'

type PathProps = {
  d: string
  fill?: string
  stroke?: string
  strokeWidth?: number
  transform?: LinearTransform
}

class PathRenderBox extends RenderBox<PathProps> {
  performLayout(constraints: BoxConstraints) {
    // Occupy the full constraint box (tight constraints expected from parent)
    this.box = {
      x: 0,
      y: 0,
      width: constraints.maxWidth,
      height: constraints.maxHeight
    }
  }

  draw(): DrawOp {
    return {
      type: 'path',
      id: this.id,
      bounds: this.box,
      path: this.props.d,
      fill: this.props.fill,
      stroke: this.props.stroke,
      stroke_width: this.props.strokeWidth,
      transform: this.props.transform
    }
  }
}

export function Path({ d, fill, stroke, strokeWidth, transform }: PathProps) {
  useRenderBox(
    () => new PathRenderBox({ d, fill, stroke, strokeWidth, transform }),
    [d, fill, stroke, strokeWidth, transform]
  )
  return null
}
